import type { ListBuilderList } from '../../../types';
import { createMerchandiserColumns } from '../columns';

/**
 * All Merchandisers list (PD-13923) — backed by the merchandiser entity
 * (/api/merchandisers), not the legacy location-with-type=merchandiser view.
 *
 * PD-16707 — opens emptiest first (Fill % low to high), the default Motor
 * City Ice had set for this tab, so the units that need ice lead the list.
 * Named by its table sort rather than a column (it was `column-fill-asc`):
 * Fill % now lives in the stacked Fill column, and the table sort resolves to
 * whichever Fill % column a layout shows, or still sorts with none.
 */
export const allMerchandisersList: ListBuilderList = {
	id: 'default-merchandisers',
	name: 'All Merchandisers',
	type: 'default',
	active: true,
	cacheTTL: 600000,
	columns: createMerchandiserColumns(),
	defaultSortId: 'fill-pct-asc',
	sortOrder: 0,
};
